export default __webpack_public_path__ + "logo-download-38b63dbc63b6f949cbee46a3b64c894f.svg";